import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "name", "checked", "error", "id", "onChange"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Checkbox/CheckboxInput.js",
    _this = this;

import React, { useState, useLayoutEffect, isValidElement } from 'react';
import { withClearInteraction, withStyledAttrs } from '../../helpers/styled';
import styled, { css } from 'styled-components';
import Text from '../Text';
import { noop } from '../../helpers';
import CheckboxTick from './tick.svg';
import { withTheme } from '../../core/ThemeProvider';
import useDevice from '../../core/hooks/useDevice';
import { responsiveStyles } from '../../core/utils/responsiveStyles';

var CheckboxInput = function CheckboxInput(_ref) {
  var label = _ref.label,
      name = _ref.name,
      checked = _ref.checked,
      error = _ref.error,
      id = _ref.id,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useDevice = useDevice(),
      isMobile = _useDevice.isMobile;

  var _useState = useState(checked),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setCheckboxValue = _useState2[1];

  var handleClick = function handleClick(e) {
    setCheckboxValue(!isChecked);
    onChange(e, !isChecked);
  };

  useLayoutEffect(function () {
    setCheckboxValue(!!checked);
  }, [checked]);
  return /*#__PURE__*/React.createElement(CheckboxWrapper, {
    "data-testid": rest['data-testid'],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("input", _extends({}, rest, {
    name: name,
    id: id,
    type: "checkbox",
    checked: isChecked,
    onChange: onChange,
    "data-testid": "checkboxInputEl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(CheckboxContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    enableInteraction: true,
    onClick: handleClick,
    "data-testid": "checkbox-button",
    error: error,
    checked: isChecked,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(CheckboxTick, {
    viewBox: "0 0 16 11",
    width: isMobile ? 12 : 16,
    height: isMobile ? 12 : 16,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 11
    }
  }))), label && ( /*#__PURE__*/isValidElement(label) ? /*#__PURE__*/React.createElement(LabelText, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 11
    }
  }, label) : /*#__PURE__*/React.createElement(LabelText, {
    dangerouslySetInnerHTML: {
      __html: label
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 11
    }
  })));
};

CheckboxInput.defaultProps = {
  checked: false,
  onChange: noop
};
export default CheckboxInput;
var CheckboxContainer = styled.div.withConfig({
  displayName: "CheckboxInput__CheckboxContainer",
  componentId: "sc-nk95e7-0"
})(["align-self:flex-start;"]);
export var CheckboxWrapper = styled.div.withConfig({
  displayName: "CheckboxInput__CheckboxWrapper",
  componentId: "sc-nk95e7-1"
})(["align-items:center;display:flex;justify-content:flex-start;box-sizing:initial;input{position:absolute;left:-999999px;top:0;opacity:0;width:1px;height:1px;}label{display:none;}"]);
var LabelText = withTheme(withStyledAttrs(Text, {
  type: 'body',
  lineHeight: 'compact'
})(function (p) {
  var _responsiveStyles, _p$coreTheme, _p$coreTheme$checkBox, _p$coreTheme$checkBox2, _p$coreTheme2, _p$coreTheme2$checkBo;

  return "\n\n  font-size: ".concat(((_responsiveStyles = responsiveStyles({
    fontSize: (_p$coreTheme = p.coreTheme) === null || _p$coreTheme === void 0 ? void 0 : (_p$coreTheme$checkBox = _p$coreTheme.checkBoxInput) === null || _p$coreTheme$checkBox === void 0 ? void 0 : _p$coreTheme$checkBox.fontSize
  }, p.coreTheme)) === null || _responsiveStyles === void 0 ? void 0 : _responsiveStyles.fontSize) || 20, "px;\n  padding-left: ").concat((_p$coreTheme$checkBox2 = (_p$coreTheme2 = p.coreTheme) === null || _p$coreTheme2 === void 0 ? void 0 : (_p$coreTheme2$checkBo = _p$coreTheme2.checkBoxInput) === null || _p$coreTheme2$checkBo === void 0 ? void 0 : _p$coreTheme2$checkBo.paddingLeft) !== null && _p$coreTheme$checkBox2 !== void 0 ? _p$coreTheme$checkBox2 : 16, "px;\n  a {\n    color: ").concat(p.coreTheme.cl_sec_d1, ";\n    font-family: ").concat(p.coreTheme.ff_sec_bold, ";\n    text-decoration: none;\n  }\n");
}));
var Checkbox = withClearInteraction(withTheme(styled.div.withConfig({
  displayName: "CheckboxInput__Checkbox",
  componentId: "sc-nk95e7-2"
})(function (_ref2) {
  var _coreTheme$checkBoxIn, _coreTheme$checkBoxIn2, _coreTheme$checkBoxIn3, _coreTheme$checkBoxIn4, _coreTheme$checkBoxIn5, _coreTheme$checkBoxIn6, _coreTheme$checkBoxIn7, _coreTheme$checkBoxIn8;

  var checked = _ref2.checked,
      error = _ref2.error,
      coreTheme = _ref2.coreTheme;
  var showError = error && !checked;
  return css(["position:relative;flex-direction:row;justify-content:center;align-items:center;height:", "px;width:", "px;border-radius:", "px;@media (min-width:", "){height:", "px;width:", "px;border-radius:", "px;}display:inline-flex;vertical-align:top;margin:0;line-height:0;border:1px solid ", ";background-color:", ";cursor:pointer;"], (_coreTheme$checkBoxIn = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$checkBoxIn2 = coreTheme.checkBoxInput) === null || _coreTheme$checkBoxIn2 === void 0 ? void 0 : _coreTheme$checkBoxIn2.width) !== null && _coreTheme$checkBoxIn !== void 0 ? _coreTheme$checkBoxIn : coreTheme.space_6, (_coreTheme$checkBoxIn3 = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$checkBoxIn4 = coreTheme.checkBoxInput) === null || _coreTheme$checkBoxIn4 === void 0 ? void 0 : _coreTheme$checkBoxIn4.height) !== null && _coreTheme$checkBoxIn3 !== void 0 ? _coreTheme$checkBoxIn3 : coreTheme.space_6, coreTheme.space_1, coreTheme.brk_xs, (_coreTheme$checkBoxIn5 = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$checkBoxIn6 = coreTheme.checkBoxInput) === null || _coreTheme$checkBoxIn6 === void 0 ? void 0 : _coreTheme$checkBoxIn6.width) !== null && _coreTheme$checkBoxIn5 !== void 0 ? _coreTheme$checkBoxIn5 : coreTheme.space_8, (_coreTheme$checkBoxIn7 = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$checkBoxIn8 = coreTheme.checkBoxInput) === null || _coreTheme$checkBoxIn8 === void 0 ? void 0 : _coreTheme$checkBoxIn8.height) !== null && _coreTheme$checkBoxIn7 !== void 0 ? _coreTheme$checkBoxIn7 : coreTheme.space_8, coreTheme.space_2, checkboxBorderColor(checked, showError, {
    checked: coreTheme.cl_sec_d1,
    error: coreTheme.cl_pri_d3,
    "default": coreTheme.cl_ter_l4
  }), checked ? coreTheme.cl_sec_d1 : coreTheme.cl_white);
})), 12, 7);

var checkboxBorderColor = function checkboxBorderColor(checked, error, colors) {
  if (checked) {
    return colors.checked;
  } else if (error) {
    return colors.error;
  } else {
    return colors["default"];
  }
};